// extracted by mini-css-extract-plugin
module.exports = {"container":"create-question_container__1uXPU","border":"create-question_border__1EqHT","withoutBottomMargin":"create-question_withoutBottomMargin__3-UkT"};